import { render, staticRenderFns } from "./BurstKeogram.vue?vue&type=template&id=5bd577ad&"
import script from "./BurstKeogram.vue?vue&type=script&lang=ts&"
export * from "./BurstKeogram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports